import React, { useEffect } from "react";
import styles from "./Style.module.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useForgotPasswordHook from "./ForgotPassword.hook";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { ArrowBack } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { actionGetClientTheme } from "../../../actions/AppSettings.action";
import { getClientDomain } from "../../../libs/domain.utils";

function ForgotPasswordView() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const appSettings = useSelector((state) => state.app_setting);
  const clientTheme = appSettings?.client_theme;

  const {
    handleSubmit,
    onBlurHandler,
    changeTextData,
    form,
    errorData,
    isSubmitting,
  } = useForgotPasswordHook();

  useEffect(() => {
    const domain = getClientDomain();
    if (domain && !clientTheme) {
      dispatch(actionGetClientTheme(domain));
    }
  }, [dispatch, clientTheme]);

  // Update favicon dynamically based on client theme
  useEffect(() => {
    if (clientTheme?.fav_icon) {
      const link = document.querySelector("link[rel='shortcut icon']");
      if (link) {
        link.href = clientTheme.fav_icon;
      }
    }
  }, [clientTheme]);

  return (
    <div className={"login"}>
      <div
        className={styles.overlay}
        style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
      ></div>
      <div
        className={styles.mainLoginView}
        style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
      ></div>
      <div className={styles.container}>
        <div className={styles.loginFlex2}>
          <div className={styles.logoImageData}>
            <img
              src={
                clientTheme?.display_logo ||
                require("../../../assets/CRMAssets/psconnect_login_logo@2x.png")
              }
              alt="logo"
              style={{
                maxHeight: "80px",
                maxWidth: "220px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
          <div className={styles.signContainer}>
            <div className={styles.loginHeaderText}>
              <Typography variant="h3">Forgot Password</Typography>

              <Typography
                variant={"body1"}
                sx={{ color: theme?.palette?.text?.secondary }}
              >
                Enter your registered email address and we'll send you a link to reset your password.
              </Typography>
            </div>

            <div className={styles.formContainer}>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.email}
                    errorText={errorData?.email}
                    label={
                      <>
                        Email ID
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={form?.email}
                    onTextChange={(text) => {
                      changeTextData(text, "email");
                    }}
                    onBlur={() => {
                      onBlurHandler("email");
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.logFlex}>
              <div className={styles.negativeSpacing} style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Link
                  to={{
                    pathname: "/login",
                    search: window.location.search,
                  }}
                  style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginLeft: '10px' }}
                >
                  <ArrowBack sx={{ fontSize: '18px', marginRight: '5px', color: theme?.palette?.primary?.main || '#2063ce' }} />
                  <Typography
                    variant="body2"
                    style={{ cursor: "pointer", color: theme?.palette?.primary?.main || '#2063ce', fontWeight: 'bold' }}
                  >
                    Back to Login
                  </Typography>
                </Link>
                <div className={styles.loginAction}>
                  <ArrowPrimaryButton
                    variant={"h6"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    SEND RESET LINK
                  </ArrowPrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default ForgotPasswordView;
